module.exports = __webpack_public_path__ + "static/media/transactionfiles.f677744f.md";